import { Divider, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ExceptionDetailSkeleton = () => (
  <Styles.MainContainer>
    <Styles.ColumnContainer>
      <Styles.RowContainer>
        <Skeleton variant="rounded" width="50%" height={56} />
        <Skeleton variant="rounded" width="50%" height={56} />
      </Styles.RowContainer>
      <Skeleton variant="rounded" width="100%" height={100} />
    </Styles.ColumnContainer>
    <Divider />
    <Styles.SectionContainer>
      <Skeleton variant="text" width={200} height={24} />
      <Styles.CheckboxGroup>
        <Skeleton variant="text" width={250} height={20} />
        <Skeleton variant="text" width={220} height={20} />
        <Skeleton variant="text" width={350} height={20} />
        <Skeleton variant="text" width={380} height={20} />
        <Skeleton variant="text" width={340} height={20} />
      </Styles.CheckboxGroup>
    </Styles.SectionContainer>
    <Divider />
    <Styles.SectionContainer>
      <Skeleton variant="text" width={300} height={24} />
      <Skeleton variant="text" width="80%" height={16} />
      <Styles.CheckboxGroup>
        <Skeleton variant="text" width={150} height={20} />
        <Skeleton variant="text" width={150} height={20} />
      </Styles.CheckboxGroup>
    </Styles.SectionContainer>
    <Divider />
    <Styles.SectionContainer>
      <Skeleton variant="text" width={120} height={24} />
      <Skeleton variant="rounded" width={250} height={28} />
    </Styles.SectionContainer>
  </Styles.MainContainer>
)

export default ExceptionDetailSkeleton
